import { SystemsQuerySession } from 'utils/systems-query-session-types';

export function createSystemsQuerySession(): SystemsQuerySession {
  let run = false;
  const listeners = new Set<() => void>();

  return {
    hasRun: () => run,
    markRun: () => {
      if (run) return;
      run = true;
      listeners.forEach((listener) => listener());
    },
    subscribe: (listener) => {
      listeners.add(listener);
      return () => {
        listeners.delete(listener);
      };
    }
  };
}

export const systemsQuerySession = createSystemsQuerySession();
